<template>
    <nav class="menu">
        <ul class="nav nav-pills nav-stacked">
            <menu-item v-for="item of menu" :item="item" ></menu-item>
        </ul>
    </nav>
</template>

<script>
  import MenuItem from './MenuItem.vue'

  export default{
    data () {
      return {
        menu: [
          { id: 1, name: 'Tableau de bord', link: '/', children: [] },
          { id: 2, name: 'Participants', link: '/contact/list', children: [] },
          {
            id: 3,
            name: 'Parcours',
            link: '/project/list',
            children: []
          },
          { id: 4, name: 'Administration', link: '/administration', children: [] }
        ]
      }
    },
    components: {
      MenuItem
    }
  }
</script>



// WEBPACK FOOTER //
// LeftMenu.vue?b9009810